// compile time full switch-case verification
export function throwBadKind(x: never): never {
    throw new Error("Unknown kind " + x);
}
